import "core-js/modules/es.array.push.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr } from "@/utils/utils";
import 'ol/ol.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import LayerImage from 'ol/layer/Image';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import Feature from 'ol/Feature';
import Overlay from 'ol/Overlay';
import maplist from '@/view/map/custom/zhuhlist';
import mappopup from '@/components/map/popup/index';
import mprompt from '@/view/map/custom/mobileprompt';
import { getPan, getPinchRotate, getdragPan } from '@/view/map/js/common';
export default {
  name: 'zzmap',
  meta: {
    title: '地图'
  },
  components: {
    maplist,
    mappopup,
    mprompt
  },
  data() {
    return {
      promptFlag: false,
      areaList: [{
        title: '金湾',
        url: 'jwmap.png',
        image: require('@/assets/map/216022/title6.png'),
        center: [60, 200],
        landscapecenter: [55, 200],
        zoom: 2,
        minZoom: 2,
        maxZoom: 4
      }, {
        title: '斗门',
        url: 'dmmap.png',
        image: require('@/assets/map/216022/title1.png'),
        center: [40, 290],
        landscapecenter: [35, 290],
        zoom: 2,
        minZoom: 2,
        maxZoom: 4
      }, {
        title: '横琴',
        url: 'hqmap.png',
        image: require('@/assets/map/216022/title2.png'),
        center: [140, 250],
        landscapecenter: [145, 250],
        zoom: 2.6,
        minZoom: 2.6,
        maxZoom: 5
      }, {
        title: '鹤洲',
        url: 'hzmap.png',
        image: require('@/assets/map/216022/title3.png'),
        center: [115, 255],
        landscapecenter: [110, 255],
        zoom: 2.5,
        minZoom: 2.5,
        maxZoom: 5
      }, {
        title: '香洲',
        url: 'xzmap.png',
        image: require('@/assets/map/216022/title4.png'),
        center: [160, 292],
        landscapecenter: [155, 292],
        zoom: 2.5,
        minZoom: 2.5,
        maxZoom: 5
      }, {
        title: '高新',
        url: 'gxmap.png',
        image: require('@/assets/map/216022/title5.png'),
        center: [180, 344],
        landscapecenter: [175, 344],
        zoom: 3,
        minZoom: 3,
        maxZoom: 5
      }],
      map: '',
      mapcontainer: '',
      drawsource: '',
      drawLayer: '',
      imageLayer: '',
      iconSource: '',
      isApp: true,
      dataList: '',
      // this.$route.query.cdId
      mapdataform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      typeList: [],
      // 分类列表
      popshowflag: false,
      fid: this.$route.query.fid,
      overlay: 'undefined',
      detail: '',
      modeltype: 4,
      cid: '',
      // promptboxFlag: false,
      loading: true,
      oneload: 0,
      area: ''
    };
  },
  mounted() {
    this.cid = Number(this.$route.query.id);
    this.getformstruct();
    this.judgeOrientation();
    window.addEventListener('orientationchange', this.judgeOrientation);
  },
  watch: {},
  methods: {
    switchArea(index) {
      this.cid = index;
      this.oneload = 0;
      this.loading = true;
      this.dataList = '';
      // 清空mapcontent内的元素
      let mapcontent = document.querySelector('#map');
      if (mapcontent.childNodes.length > 0) {
        mapcontent.removeChild(mapcontent.childNodes[0]);
      }
      this.map = null;
      this.staticmap();
      this.getmapdataform();
    },
    judgeOrientation() {
      this.loading = true;
      // location.reload()
      if (window.orientation === 180 || window.orientation === 0) {
        // alert('竖屏状态！')
        // this.promptboxFlag = true
        this.promptFlag = false;
        this.setContainerWH();
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // alert('横屏状态！')
        // this.promptboxFlag = false
        this.promptFlag = true;
      }
      this.getmapdataform();
      this.$nextTick(() => {
        this.staticmap();
      });
    },
    // 静态地图
    staticmap() {
      // 清空mapcontent内的元素
      let mapcontent = document.querySelector('#map');
      if (mapcontent.childNodes.length > 0) {
        mapcontent.removeChild(mapcontent.childNodes[0]);
      }
      this.map = null;
      this.mapcontainer = this.$refs.maps;
      this.area = this.areaList.filter((item, index) => {
        return this.cid === index;
      });
      let extent = [0, 0, 480, 480];
      let projection = new Projection({
        projection: 'EPSG:4326',
        code: 'xkcd-image',
        units: 'pixels',
        extent: extent
      });
      this.imageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: 'images/' + this.$route.query.fid + '/' + this.area[0].url,
          //这里添加静态图片的地址
          projection: projection,
          imageExtent: extent
        })
      });
      this.drawsource = new VectorSource();
      this.drawLayer = new VectorLayer({
        source: this.drawsource,
        style: this.styleFunction
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      // console.log(this.promptFlag)
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        layers: [this.imageLayer, this.iconLayer, this.drawLayer],
        target: this.mapcontainer,
        view: new View({
          projection: projection,
          center: this.promptFlag ? this.area[0].landscapecenter : this.area[0].center,
          zoom: this.area[0].zoom,
          minZoom: this.area[0].minZoom,
          maxZoom: this.area[0].maxZoom,
          rotation: this.promptFlag ? 0 : 1.58
        })
      });

      // this.mapLoadEnd(this.mapconfigdatas)
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      let that = this;
      this.map.on('moveend', function (event) {
        that.oneload++;
        // console.log(that.oneload)
        if (that.oneload < 2) return;
        that.resolutionchange(event);
      });
      // getdragPan(this.map)
      // getPan(this.map)
      getPinchRotate(this.map);
    },
    resolutionchange(event) {
      this.iconSource.clear();
      this.dataList.forEach(elem => {
        this.createPoint(elem.itemformdata, elem);
      });
    },
    listmarkerclick(item) {
      this.markerclick(item, 1);
    },
    // 获取表单字段结构 属性 分类数据
    getformstruct() {
      let params = {
        formId: '260297',
        pageSize: 1,
        deptId: this.fid,
        orderBy: 'manualOrderTop,manualOrder',
        orderType: ''
      };
      this.$api.singleadvanceSearch(params).then(res => {
        if (res.dataList.length > 0) {
          this.typeList = [];
          res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            this.typeList.push({
              title: item.itemformdata.title || item.itemformdata[1],
              value: item.itemformdata.title || item.itemformdata[1],
              formUserId: item.id,
              formId: item.formId,
              disabled: true,
              id: item.itemformdata[2]
            });
            return item;
          });
        }
      });
    },
    // 获取地图点数据
    getmapdataform() {
      let _this = this;
      this.mapdataform.deptId = this.fid;
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        // console.log(res)
        if (res.dataList.length > 0) {
          _this.loading = false;
          if (res.totalPage === 1) {
            _this.iconSource.clear();
            _this.dataformat(res);
          } else {
            if (_this.mapdataform.page === 1) {
              _this.iconSource.clear();
            }
            _this.dataformat(res);
            _this.mapdataform.page++;
            if (res.totalPage >= _this.mapdataform.page) _this.getmapdataform();
          }
        }
      }).catch(e => {
        // console.log(e)
      });
    },
    dataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        if (itemformat.pca !== undefined && itemformat.pca.toString() !== '') {
          let areaArr = itemformat.pca.split('|')[1];
          item.itemformdata.area = areaArr.split(',')[2];
        }
        if (item.itemformdata.area !== undefined && item.itemformdata.area.includes(this.areaList[Number(this.cid)].title)) {
          this.createPoint(itemformat, item);
        }
      });
      if (this.mapdataform.page === 1) {
        this.dataList = res.dataList.filter(item => {
          return item.itemformdata.area !== undefined && item.itemformdata.area.includes(this.areaList[Number(this.cid)].title);
        });
      } else {
        this.dataList.concat(res.dataList.filter(item => {
          return item.itemformdata.area !== undefined && item.itemformdata.area.includes(this.areaList[Number(this.cid)].title);
        }));
      }
      // console.log(this.dataList)
    },
    // 点击当前 定位点 详情
    markerclick(evt, type) {
      let feature = '';
      if (evt.id) {
        feature = evt;
      } else {
        feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
          return feature;
        });
      }
      this.overlay = undefined;
      this.popshowflag = false;
      if (feature) {
        let featureId = feature.id ? feature.id : feature.get('id');
        let _this = this;
        this.$api.singleformUserId(this.fid, this.mapdataform.formId, featureId).then(res => {
          let detaildata = res.formUserList[0].formData;
          let deatilObj = {
            currentShowtype: 'banner'
          };
          detaildata.forEach(item => {
            deatilObj[transformStr3(item.alias)] = _this.getformitemdata(item);
          });
          if (deatilObj.video.length > 0) {
            let videoTimer = setTimeout(() => {
              if (deatilObj.video[0].url !== undefined) {
                clearTimeout(videoTimer);
                deatilObj.cVideourl = deatilObj.video[0].url;
                deatilObj.cVideotitle = deatilObj.video[0].title;
              }
            }, 500);
            // console.log(_this.currentVideo)
          }
          this.detail = deatilObj;

          // 外链是否打开新窗口字段判断
          if (deatilObj['44'] !== '') {
            if (this.detail.linkTarget !== undefined && this.detail.linkTarget === '是') {
              window.open(deatilObj['44']);
              return;
            }
            location.href = deatilObj['44'];
          } else {
            if (deatilObj['42'] === '') return;
            if (deatilObj['42'] === '链接' && deatilObj['44'] === '') return;
            if (deatilObj['42'] === '仅展示') return;
            // 珠海点击弹窗 使用overlay方式 可跟随点
            this.popshowflag = true;
          }
        });
      }
    },
    // 处理表单数据
    getformitemdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'videobox' || data.compt === 'fileupload' || data.compt === 'imagebox' || data.compt === 'location' || data.compt === 'selectmultibox') return data.values.length ? data.values : '';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    // 弹窗关闭事件
    closeHandle() {
      this.detail = '';
      this.popshowflag = false;
    },
    // 点击当前 定位点 详情
    createPoint(itemformat, item) {
      let _this = this;
      if (itemformat['34'] === '隐藏') return false;
      let c = itemformat['mapCoordinates'].split(',');
      let cX = Number(c[0]);
      let cY = Number(c[1]);
      let iconFeature = new Feature({
        geometry: new Point(fromLonLat([cX, cY])),
        id: item.id,
        name: itemformat['placeName']
      });
      let textstyle = '';
      // console.log(itemformat[4][0].fileUrl)
      let imgname = item.itemformdata['4'][0].name;
      let number = imgname.replace(/[^0-9]/ig, '');
      let imageicon = itemformat[4].length === 0 ? '' : new StyleIcon({
        src: 'images/' + this.$route.query.fid + '/icon' + number + '.png',
        offset: [0, 0],
        width: 100
      });
      iconFeature.setStyle(new Style({
        image: itemformat.show4 === '否' ? '' : imageicon,
        text: itemformat.showplaceName === '否' ? '' : textstyle
      }));
      let zoom = this.map.getView().getZoom();
      let addNum = zoom === this.area[0].zoom ? 0 : zoom * 0.14;
      let iconstyle = iconFeature.getStyle().getImage().setScale(0.65 + addNum);
      _this.iconSource.addFeature(iconFeature);
    },
    setContainerWH() {
      let width = window.screen.width;
      let height = window.screen.height;
      if (width < height) {
        let box = document.querySelector('#mapcontainer');
        box.style.width = height + 'px';
        box.style.height = width + 'px';
        box.style.top = (height - width) / 2 + 'px';
        box.style.left = 0 - (height - width) / 2 + 'px';
      }
    },
    goHome() {
      let query = this.$route.query;
      delete query.id;
      this.$router.replace({
        path: '/zzmobile',
        query: query
      });
    },
    showprompt() {
      // if (!this.promptFlag) this.promptboxFlag = true
    }
  }
};